import { render, staticRenderFns } from "./PlacementsTabStep.vue?vue&type=template&id=d942f11a"
import script from "./PlacementsTabStep.vue?vue&type=script&lang=js"
export * from "./PlacementsTabStep.vue?vue&type=script&lang=js"
import style0 from "./PlacementsTabStep.vue?vue&type=style&index=0&id=d942f11a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports